"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationItem = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
// import i18n from "i18n-js";
const styled_components_1 = __importDefault(require("styled-components"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const useFetchSvg_1 = __importDefault(require("../../../common/helpers/Hooks/useFetchSvg"));
const helpers_1 = require("../../../common/helpers/helpers");
const NotificationItemWrapper = styled_components_1.default.div `
  display: flex;
  padding: 10px 0px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
  gap: 10px;

  @media (min-width: 1000px) {
    &.selected {
      background-color: #f5f5f5;
    }
  }

  &:hover {
    cursor: pointer;
  }
`;
const NotificationImage = styled_components_1.default.div `
  position: relative;

  img {
    height: 120px;
    width: 120px;
    border-radius: 10px;

    @media (max-width: 480px) {
      height: 100px;
      width: 100px;
    }
  }
  .image-placeholder {
    height: 120px;
    width: 120px;

    background: linear-gradient(
      12deg,
      ${(props) => props.theme.palette.mainAppColor.dark} 5%,
      ${(props) => props.theme.palette.mainAppColor.light} 25%,
      ${(props) => props.theme.palette.mainAppColor.main} 100%
    );

    border-radius: 10px;

    @media (max-width: 480px) {
      height: 100px;
      width: 100px;
    }
  }
  .svg-wrapper {
    height: 32px;
    width: 32px;
    position: absolute;
    bottom: 0;
    right: -5px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.palette.mainAppColor.main};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
    svg {
      transform: scale(0.45);
      overflow: visible;
      path,
      circle {
        fill: ${(props) => props.theme.palette.mainAppColor.contrastText};
      }
    }
  }
`;
const NotificationDetails = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
`;
const NotificationTitleWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  gap: 10px;

  .notification-status {
    display: flex;
    align-items: center;
  }

  .notification-title {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .notification-read {
    background-color: ${(props) => props.theme.palette.secondary.main};
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin: 0 5px;
  }
`;
const NotificationDetailsWrapper = styled_components_1.default.div `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 70px;

  .notification-details {
    color: rgba(0, 0, 0, 60%);
  }

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
`;
const NotificationActivityStatus = styled_components_1.default.div `
  display: flex;
  align-items: center;
  .notification-activity-status {
    background-color: rgb(255, 59, 48);
    height: 10px;
    width: 10px;
    border-radius: 50%;
    margin-right: 5px;
  }
`;
// const timeAgo = ( date, timeOfNotification ) => {
//     const now = new Date();
//     const givenDate = new Date( date );
//     const differenceInSeconds = Math.floor( ( now - givenDate ) / 1000 );
//     if ( differenceInSeconds >= 86400 && differenceInSeconds < 172800 ) {
//         return i18n.t( "dictionary.dates.yesterday" );
//     } else if ( differenceInSeconds >= 60 && differenceInSeconds <= 3600 ) {
//         const minutesAgo = Math.floor( differenceInSeconds / 60 );
//         return `${ minutesAgo } minute${ minutesAgo === 1 ? "" : "s" } ago`;
//     } else if ( differenceInSeconds > 0 && differenceInSeconds < 60 ) {
//         return `${ differenceInSeconds } second${ differenceInSeconds === 1 ? "" : "s" } ago`;
//     }
//     return timeOfNotification;
// };
const NotificationItem = (props) => {
    const { notification, checkDetails, currentLocale, selectedNotification, groupKey, } = props;
    const { time: timeOfNotification, date: dateOfNotification } = helpers_1.Helpers.getDateFromStringDependingLocale(notification.sentAt, currentLocale);
    const loadedSvg = notification.iconUrl
        ? (0, useFetchSvg_1.default)(notification.iconUrl)
        : null;
    // const showNotificationTime = timeAgo( notification.sentAt, timeOfNotification );
    const selectedClass = selectedNotification &&
        selectedNotification.id &&
        notification.id === selectedNotification.id
        ? "selected"
        : "";
    return (react_1.default.createElement(NotificationItemWrapper, { className: selectedClass, onClick: () => {
            checkDetails(notification);
        } },
        react_1.default.createElement(NotificationImage, null,
            notification.thumbnailUrl ? (react_1.default.createElement("img", { src: notification.thumbnailUrl, alt: "placeholder" })) : (react_1.default.createElement("div", { className: "image-placeholder" })),
            react_1.default.createElement("div", { className: "svg-wrapper", dangerouslySetInnerHTML: {
                    __html: loadedSvg,
                } })),
        react_1.default.createElement(NotificationDetails, null,
            react_1.default.createElement(NotificationTitleWrapper, null,
                react_1.default.createElement(Typography_1.default, { className: "notification-title", variant: "h5" }, notification.title),
                react_1.default.createElement("div", { className: "notification-status" },
                    groupKey === "notification_grouping_earlier" ? (react_1.default.createElement(Typography_1.default, { display: "inline-block", variant: "body2" }, dateOfNotification)) : (react_1.default.createElement(Typography_1.default, { className: "notification-time", variant: "body2" }, timeOfNotification)),
                    !notification.read && react_1.default.createElement("div", { className: "notification-read" }))),
            react_1.default.createElement(NotificationDetailsWrapper, null,
                react_1.default.createElement(Typography_1.default, { className: "notification-details", variant: "body1" },
                    notification.body,
                    " ")),
            react_1.default.createElement(NotificationActivityStatus, null))));
};
exports.NotificationItem = NotificationItem;
const mapStoreToProps = (store) => ({
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(exports.NotificationItem));
